import Vue from "vue";
import VueRouter from "vue-router";
import LookupStakeholders from "WhoDoYouKnowComponents/LookupStakeholders";
import StakeholderSearchWrapper from "WhoDoYouKnowComponents/StakeholderSearchWrapper";
import StakeholderResults from "WhoDoYouKnowComponents/StakeholderResults";
import ThankYou from "WhoDoYouKnowComponents/ThankYou"
import Routes from "Constants/campaign/whodoyouknow/routeNames";

Vue.use(VueRouter);

const routes = [
  {
    component: LookupStakeholders,
    name: Routes.LOOKUP_STAKEHOLDERS,
    path: "/"
  },
  {
    components: {
      default: StakeholderResults,
      stakeholderSearchWrapper: StakeholderSearchWrapper
    },
    name: Routes.STAKEHOLDER_RESULTS,
    path: "/stakeholder-results"
  },
  {
    component: ThankYou,
    name: Routes.THANK_YOU,
    path: "/thank-you"
  },
  {
    path: "*",
    redirect: "/"
  }
];

export default new VueRouter({
  base: window.location.pathname,
  routes
});
